import React from 'react';
import { NavLink, useParams } from 'react-router-dom';
import { usePageMeta } from '../hooks/usePageMeta';
import { legalDocs, LEGAL_DRAFT_NOTICE } from '../data/legal';
import { formatDate } from '../utils/format';
import { PageHero } from '../components/ui/PageHero';
import { NotFound } from './NotFound';
export function Legal() {
  const {
    slug
  } = useParams();
  const doc = legalDocs.find(d => d.slug === slug);
  usePageMeta(doc?.title ?? 'Page not found', doc?.summary ?? 'This page could not be found.');
  if (!doc) return <NotFound data-id="element-1009" data-mp="etzpznq3yw1v" />;
  return <>
      <PageHero crumbs={[{
      label: 'Legal'
    }, {
      label: doc.title
    }]} title={doc.title} intro={doc.summary} data-id="element-1010" data-mp="3isgfglgqa9" />
      <section className="bg-white py-16 md:py-20" data-id="element-1011" data-mp="52c5k6ryyf9w">
        <div className="container-page grid gap-12 lg:grid-cols-12" data-id="element-1012" data-mp="53526ex7roeb">
          <nav aria-label="Legal pages" className="lg:col-span-3" data-id="element-1013" data-mp="3n7ymcqgzsjfw">
            <ul className="space-y-1 lg:sticky lg:top-28" data-id="element-1014" data-mp="3s7bhrzlxiyu3">
              {legalDocs.map(d => <li key={d.slug} data-id="element-1015" data-mp="27l4pt55xsmfq">
                  <NavLink to={`/legal/${d.slug}`} className={({
                isActive
              }) => `block rounded-md px-3 py-2 text-sm transition-colors duration-150 ${isActive ? 'bg-midnight text-white' : 'text-muted hover:bg-ivory hover:text-ink'}`} data-id="element-1016" data-mp="27k3fj2wqw3z2">
                    {d.title}
                  </NavLink>
                </li>)}
            </ul>
          </nav>
          <article className="prose-corventa max-w-3xl lg:col-span-8" data-id="element-1017" data-mp="1jvk8srtcfz93">
            <p className="!text-sm rounded-md border border-gold/40 bg-gold-100 px-4 py-3 !text-gold-700" data-id="element-1018" data-mp="1jxdcby8nu3cv">{LEGAL_DRAFT_NOTICE}</p>
            <p className="!text-sm" data-id="element-1019" data-mp="1ttq4ussgyb61">Last updated {formatDate(doc.updated)}</p>
            {doc.sections.map(s => <section key={s.heading} data-id="element-1020" data-mp="163m7321yp5my">
                <h2 data-id="element-1021" data-mp="162b1cwoyhnt7">{s.heading}</h2>
                {s.body.map(b => <p key={b.slice(0, 24)} data-id="element-1022" data-mp="11417qqivqv9p">{b}</p>)}
              </section>)}
          </article>
        </div>
      </section>
    </>;
}